// extracted by mini-css-extract-plugin
export default {"homepage":"HomePage_homepage__y4Wwx","gradientFlow":"HomePage_gradientFlow__8UMRY"};